import { useApolloClient } from '@apollo/react-hooks';
import { uniqBy } from 'lodash';
import React, { useState } from 'react';
import { createContext, FC } from 'react';
import SnackVariableInterface from '../Interfaces/SnackVariableInterface';
import { displaySnackBar } from '../Utils/snackBarUtils';

export interface DestinationsInterface {
  id: string;
  name: string;
  phone: string;
  address: string;
  addressBookId: string;
  latitude: string;
  longitude: string;
}

interface DestinationsInputProps {
  destinations: DestinationsInterface[];
  addDestination: (destination: DestinationsInterface) => void;
  removeDestination: (id: string) => void;
  clearDestinations: () => void;
  hasActiveDestination: () => boolean; // Ajout d'une méthode pour vérifier si une destination est active
}

export const DestinationsContext = createContext<DestinationsInputProps>({
  destinations: [],
  addDestination: (destination: DestinationsInterface) => {},
  removeDestination: (id: string) => {},
  clearDestinations: () => {},
  hasActiveDestination: () => false,
});

export const DestinationsProvider: FC = ({ children }) => {
  const [destinations, setDestinations] = useState<DestinationsInterface[]>([]);
  const client = useApolloClient();

  const hasActiveDestination = () => destinations.length > 0;

  return (
    <DestinationsContext.Provider
      value={{
        destinations,
        hasActiveDestination,
        addDestination: (destination: DestinationsInterface) => {
          if (hasActiveDestination()) {
            const snackBarData: SnackVariableInterface = {
              type: 'ERROR',
              message: 'Vous devez supprimer la destination actuelle avant d\'en ajouter une nouvelle.',
              isOpen: true,
            };
            displaySnackBar(client, snackBarData);
          } else {
            setDestinations([destination]);
          }
        },
        removeDestination: (id: string) => {
          const newDest = destinations.filter(destination => destination.id !== id);
          setDestinations(newDest);
        },
        clearDestinations: () => {
          setDestinations([]);
        },
      }}>
      {children}
    </DestinationsContext.Provider>
  );
};